module.exports = __webpack_public_path__ + "media/images/favicons/tableauconnect-d25a3626f53aae64ade7996d119748d5eb6b74fc0e2f3e10ab1aba24c85c9aa8.ico";